import React from 'react';
import {useMatch} from 'react-router-dom';
import {Dropdown} from 'antd';
import MenuOverlay from '@/app/wrapper/FlowAppLayoutWrapper/MenuOverlay';
import {DownOutlined} from '@/icons';
import {Link} from 'react-router-dom';

AppModuleMenu.propTypes = {};

function AppModuleMenu() {
    const match = useMatch('/apps/:appId/*');
    // console.log('-----AppModuleMenu', match);
    if (!match) {
        return (
            <li>
                <Link to="/">应用管理</Link>
            </li>
        );
    } else {
        return (
            <li>
                <Dropdown overlay={<MenuOverlay menuKey="appMenu" />} placement="bottomCenter">
                    <Link to="/">
                        应用管理 <DownOutlined style={{marginLeft: 10}} />
                    </Link>
                </Dropdown>
            </li>
        );
    }
}

export default AppModuleMenu;
